module.exports = __webpack_public_path__ + "img/White Logo.94a9a5f1.png";